import axios, { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';

import { MasterCompany } from '../models/company/MasterCompany';
import { ResponseList } from '../models/Response';

export type UseMasterCompanyProps = {
    sid?: string;
    status?: 'active' | 'inactive';
};

export function useMasterCompany(props: UseMasterCompanyProps) {
    const { sid, status } = props;

    return useQuery({
        queryKey: ['master-company', { sid, status }],
        queryFn: ({ signal }) =>
            axios.get<ResponseList<MasterCompany>>('/v1/company_master', {
                signal,
                params: {
                    sid,
                    status
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        'WF_APPLICATION'
                    )}`
                }
            }),
        select: (response: AxiosResponse<ResponseList<MasterCompany>>) =>
            response.data.result_list,
        refetchOnWindowFocus: false
    });
}
